import React, { useState, useEffect } from 'react';
import { useForm, ErrorMessage } from 'react-hook-form'
import { Row, Col, Input, Button, Modal, FormGroup, ModalBody, Label } from 'reactstrap';
import { useTranslation } from "react-i18next";
import Notification from './../Elements/Notification';
import RegexLibrary from "../../utils/Regex";

// Services
import HttpAuth from '../../services/http/Auth';
import WarningException from '../../services/exception/WarningException';


export const ModalForgotPassword = (props:any) => {
    const { t } = useTranslation();
    const { register, handleSubmit, errors, watch } = useForm();
    const [loading, setLoading] = useState(false);

    const onSubmit = async (data:any) => {
        setLoading(true);
        let response;
        try {
          response = await new HttpAuth().getForgotPassword(data.email);
          if (response){
            setLoading(false);
            props.clickSubmit();
          }
        } catch (err) {
            setLoading(false);
            Notification.displayException(err);
            return;
        }
    };

    return (
        <Modal isOpen={props.modal} toggle={props.toggleModal} centered={true} size={'md'}>
            <ModalBody>
                <Row>
                    <Col xs={12} className="text-center pt-5 pb-5" style={{letterSpacing: '1px'}}>
                        <h4>{t('LoginForm-forgotPassword-title')}</h4>
                    </Col>
                </Row>
                <form onSubmit={handleSubmit(onSubmit)} className="form-horizontal second-font">
                  <fieldset>
                      <FormGroup row>
                          <div className="col-md-12">
                              <Input type="text" name="email" innerRef={register({ required: 'common-required', pattern: {
                                value: RegexLibrary.email,
                                message: "common-invalid"}})} 
                                autoFocus={true} className={`${errors.email? 'is-invalid' : ''}`} placeholder={t('Signup.Email.Placeholder')}  />
                              <ErrorMessage errors={errors} name="email">
                                {({ message }) => <span className="invalid-feedback">{t(message)}</span> }
                              </ErrorMessage>
                          </div>
                      </FormGroup>
                  </fieldset>
                  <Row>
                    <Col xl={12} sm={12} className="text-center mt-3 mb-3">
                      <Button type="submit" color="primary" size="lg" disabled={loading}>
                        {t('LoginForm-forgotPassword-submit')}
                        { loading &&
                          <i className="fas fa-spinner ml-2 fa-spin"></i>
                        }
                      </Button>
                    </Col>
                  </Row>
              </form>
            </ModalBody>
        </Modal>
    );
};